module.exports = __webpack_public_path__ + "img/HT.96e33c78.svg";